module.exports = __webpack_public_path__ + "static/media/close.b14a073d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/close.svg
// module id = 1089
// module chunks = 0